"use client";

import type { Tag } from "@/app/types/blogTypes";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

type TagsProps = {
  tags: Tag[];
  onClose?: () => void;
};

import "./select.css";

export function BlogTags({ tags, onClose }: TagsProps) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const currentTag = searchParams.get("tag") || "all";

  const handleTagChange = (tag: string) => {
    const params = new URLSearchParams(searchParams);
    if (tag === "all") {
      params.delete("tag");
    } else {
      params.set("tag", tag);
    }
    router.push(`${pathname}?${params.toString()}`);
    onClose && onClose();
  };

  return (
    <select
      value={currentTag}
      onChange={(e) =>
        handleTagChange(e.target.value === "Todos" ? "all" : e.target.value)
      }
      className="select-custom text-sm h-12 px-4 rounded-2xl border focus:ring-0 focus:outline-none text-gray-900 placeholder-neutral-400"
    >
      <option value="Todos">Todos os Tópicos</option>
      {tags.map((tag) => (
        <option key={tag.id} value={tag.slug}>
          {tag.name}
        </option>
      ))}
    </select>
  );
}
